// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ROOT = '/root';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  // terms: '/terms',
  // privacyPolicy: '/privacy-policy',
  termsPolicy: '/terms-and-privacy-policy',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
  createCompany: '/company/create',
};

export const PATH_ROOT = {
  root: ROOTS_ROOT,
  general: {
    app: path(ROOTS_ROOT, '/app'),
  },
  company: {
    root: path(ROOTS_ROOT, '/company'),
    list: path(ROOTS_ROOT, '/company/list'),
  },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/company'),
    activitie: path(ROOTS_DASHBOARD, '/activities'),
    activityList: path(ROOTS_DASHBOARD, '/activity-list'),
    events: path(ROOTS_DASHBOARD, '/events'),
    alerts: path(ROOTS_DASHBOARD, '/alerts'),
    timekeeping: path(ROOTS_DASHBOARD, '/timekeepings'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey'),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/:userId/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    // Group
    group: {
      list: path(ROOTS_DASHBOARD, '/user/group/list'),
      create: path(ROOTS_DASHBOARD, '/user/group/create'),
      editById: path(ROOTS_DASHBOARD, `/user/group/edit/:groupId`),
    },
    role: {
      list: path(ROOTS_DASHBOARD, '/user/role'),
      create: path(ROOTS_DASHBOARD, '/user/role/create'),
      editById: path(ROOTS_DASHBOARD, `/user/role/:roleId/edit`),
      detail: path(ROOTS_DASHBOARD, `/user/role/:roleId`),
    },
  },
  checklist: {
    root: path(ROOTS_DASHBOARD, '/checklist'),
    list: path(ROOTS_DASHBOARD, '/checklist'),
    detail: path(ROOTS_DASHBOARD, '/checklist/:id'),
    edit: path(ROOTS_DASHBOARD, '/checklist/:id/edit'),
    create: path(ROOTS_DASHBOARD, '/checklist/create'),
  },
  places: {
    root: path(ROOTS_DASHBOARD, '/places'),
  },
  devices: {
    root: path(ROOTS_DASHBOARD, '/devices'),
    create: path(ROOTS_DASHBOARD, '/devices/create'),
    edit: path(ROOTS_DASHBOARD, '/devices/:id/edit'),
    detail: path(ROOTS_DASHBOARD, '/devices/:id'),
  },
  schedules: {
    root: path(ROOTS_DASHBOARD, '/schedules'),
    list: path(ROOTS_DASHBOARD, '/schedules/list'),
    detail: path(ROOTS_DASHBOARD, '/schedules/detail/:id'),
    create: path(ROOTS_DASHBOARD, '/schedules/create'),
    event: path(ROOTS_DASHBOARD, '/schedules/event/:id'),
  },
  events: {
    root: path(ROOTS_DASHBOARD, '/events'),
    detail: path(ROOTS_DASHBOARD, '/events/:id'),
  },
  alerts: {
    root: path(ROOTS_DASHBOARD, '/alerts'),
    detail: path(ROOTS_DASHBOARD, '/alerts/:id'),
  },
  timekeepings: {
    root: path(ROOTS_DASHBOARD, '/timekeepings'),
    detail: path(ROOTS_DASHBOARD, '/timekeepings/:id'),
  },
  activityList: {
    root: path(ROOTS_DASHBOARD, '/activity-list'),
    detail: path(ROOTS_DASHBOARD, '/activity-list/:id'),
  },
  // eCommerce: {
  //   root: path(ROOTS_DASHBOARD, '/e-commerce'),
  //   shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
  //   product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
  //   productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  //   list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
  //   newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
  //   editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
  //   checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
  //   invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  // },
  // blog: {
  //   root: path(ROOTS_DASHBOARD, '/blog'),
  //   posts: path(ROOTS_DASHBOARD, '/blog/posts'),
  //   post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
  //   postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  //   newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  // }
};

// export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
